/* PW v94.9 round 4 (16 Oct).
   1. Peek lines: Rusty (and Cash) never use exclamation marks, per the brand voice bank. assets/pw-cast.js keeps its
      line database on window.PWCast.L; this rewrites it in place once every deferred script has run
      (DOMContentLoaded fires after them), so the first line shown is already calm.
   2. Open Mic: moves the mic stand from the sign to center stage on the wooden floor (styles: pw-949f.css section 6).
   3. Make it yours card: a small rise as it scrolls in (styles: pw-949f.css section 7). */
(function () {
  function castCalm() {
    var c = window.PWCast; if (!c || !c.L || c.L.__pw949) return;
    Object.keys(c.L).forEach(function (k) { c.L[k].forEach(function (l) {
      l[2] = l[2].replace(/!+(\s*\?)/g, '$1').replace(/!+/g, '.').replace(/\.(\s*\.)+/g, '.');
    }); });
    try { Object.defineProperty(c.L, '__pw949', { value: 1 }); } catch (e) {}
  }
  function micCenter() {
    var sec = document.querySelector('.ns-funny.pw949-fc'), mic = sec && sec.querySelector('.pw949-mic');
    if (mic && mic.parentNode !== sec) sec.appendChild(mic);
  }
  function mkyRise() {
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    [].forEach.call(document.querySelectorAll('.pw-mky:not(.pw949-rise)'), function (k) {
      var b = k.getBoundingClientRect(); if (b.top < innerHeight && b.bottom > 0) return; /* already on screen: leave it */
      k.classList.add('pw949-rise');
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { k.classList.add('pw949-in'); io.disconnect(); } }); }, { threshold: 0.12 });
      io.observe(k);
    });
  }
  function run() { castCalm(); micCenter(); mkyRise(); }
  window.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', function () { setTimeout(micCenter, 0); });
})();
